import { EventTypes, track } from '@mc/track-event'

export const trackHighlight = (location) => {
  track(EventTypes.ARTICLE_PAGE_CLICK, {
    action: 'highlight',
    location,
    referrer: document.referrer,
    url: window.location.href,
  })
}
